var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M0,7A7.008,7.008,0,0,1,7,0,.528.528,0,1,1,7,1.055,5.945,5.945,0,1,0,12.945,7,.528.528,0,1,1,14,7,7,7,0,0,1,0,7ZM6.5,9.516a.528.528,0,0,1-.377-.171L3.464,6.461a.528.528,0,0,1,.776-.714L6.524,8.226l6.33-6.313a.528.528,0,0,1,.745.749L6.88,9.361a.526.526,0,0,1-.372.155Z",
    fill: "#5bb553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.3cdffa3d9f0bdf02deef6da2a031cefc.svg";
export { ForwardRef as ReactComponent };